import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE } from '../data/content';
const guarantees = ['Acceso inmediato', 'Para docentes de Hispanoamérica', 'Pago seguro'];
export function Hero() {
  return <header className="w-full bg-cream-100 px-6 pb-10 pt-5 sm:pt-7" data-id="element-86" data-mp="4m8m0bnacpke">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-87" data-mp="4jvx1ej41exu">
        <span className="rounded-full bg-cream-200 px-5 py-1.5 text-xs font-semibold tracking-[0.22em] text-forest-700" data-id="element-88" data-mp="128pft6wt8l1e">
          KIT INSTRUMENTACIÓN INDUSTRIAL 2026
        </span>

        <h1 className="mt-4 font-display text-4xl font-bold leading-[1.02] text-forest-800 sm:text-6xl lg:text-7xl" data-id="element-89" data-mp="s9q6rn84undv">
          Del Sensor al Aula.
          <span className="block text-ember-500" data-id="element-90" data-mp="3d1a83izra9cr">Todo resuelto.</span>
        </h1>

        <img src={HERO_IMAGE} alt="Los 6 volúmenes del Kit Instrumentación Industrial 2026 junto a los 5 bonos, material imprimible y recursos digitales" width={1000} height={1000} fetchPriority="high" decoding="async" className="-my-4 h-auto w-full max-w-xl sm:-my-6" data-id="element-91" data-mp="3cz5vmcnsk20v" />

        <p className="max-w-2xl text-base leading-relaxed text-forest-700/75 sm:text-lg" data-id="element-92" data-mp="3o73qeex4209n">
          Kit Instrumentación Industrial con 6 volúmenes técnicos, 5 bonos estratégicos e implementación
          docente 360°.
        </p>

        <ul className="mt-4 flex flex-col items-center gap-1.5 text-sm text-forest-600 sm:flex-row sm:gap-7 sm:text-base" data-id="element-93" data-mp="30i18r72h87f5">
          {guarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-94" data-mp="359j9pv4i2804">
              <CheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-95" data-mp="2qk3m2o09mion" />
              {item}
            </li>)}
        </ul>

        <CtaButton className="mt-6" source="hero" data-id="element-96" data-mp="2vjzmkd9r7rzg" />

        <div className="mt-4 flex flex-col items-center gap-2 text-sm text-forest-700/70 sm:flex-row sm:gap-5" data-id="element-97" data-mp="2hj5ejvqmbt1b">
          <span className="flex items-center gap-2" data-id="element-98" data-mp="2lkilk95g629t">
            <span className="flex" aria-hidden="true" data-id="element-99" data-mp="2ljz22o05f5to">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" data-id="element-100" data-mp="s2td3kfiu7p7" />)}
            </span>
            4.9/5 — +150 docentes
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-101" data-mp="ibyr8h66ta4a" />
          <span className="flex items-center gap-2" data-id="element-102" data-mp="i9vu7d6magq2">
            <ShieldCheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-103" data-mp="degeefp1uar0" />
            Garantía 7 Días
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-104" data-mp="1ayt7t2zvvpch" />
          <span className="flex items-center gap-2" data-id="element-105" data-mp="162m0b5rua5sf">
            <CreditCardIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-106" data-mp="1126mye7k4yag" />
            Tarjeta · Mercado Pago
          </span>
        </div>
      </div>
    </header>;
}